import 'arrive'
import { gsap } from 'gsap'
import $ from 'jquery';

document.arrive('.btn-toggle', {existing: true}, function() {

  const button = this;
  const text = button.closest('.text-toggle');
  const inner = text.querySelector('.inner');
  const label = button.querySelector('.label');

  const textClose = button.dataset.close;
  const textOpen = button.dataset.open;
  const textVisible = !!text.dataset.visible && text.dataset.visible <= 10 ? text.dataset.visible : 1;
  const getVisibleText = () => {
    let height = 0;
    let count = 0;
    $(inner).find('p').each(function() {
      if(count < textVisible) {
        height += $(this).outerHeight(true);
        count++;
      }
    })

    return height;
  }

  $(inner).height(getVisibleText());

  $(document).ready( function () {
    $(inner).height(getVisibleText());
  });

  button.onclick = function() {

    if ( this.classList.contains('active') ) {
      if(!button.dataset.noscroll) window.scrollTo({ top: $(inner).offset().top - 100, behavior: 'smooth' });

      if(!!button.dataset.alertmodal) {
        $('.modal-js[data-name="' + button.dataset.alertmodal + '"]').removeClass('expanded');
      }

      gsap.to(inner, {

        height: getVisibleText() + 'px',
        ease: 'linear',
        duration: 0.3

      });

      label.innerHTML = textOpen;

      text.classList.remove('active');
      this.classList.remove('active');

    } else {

      gsap.to(inner, {

        height: 'auto',
        ease: 'linear',
        duration: 0.3

      });

      if(!!button.dataset.alertmodal) {
        $('.modal-js[data-name="' + button.dataset.alertmodal + '"]').addClass('expanded');
      }

      label.innerHTML = textClose;

      text.classList.add('active');
      this.classList.add('active');

    }

  }
})
